document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('.menu-toggle'),menu=document.getElementById('MobileMenu');if(toggle&&menu){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;});}});
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('[data-chrome-product]');
  if(!root)return;
  const gallery=root.querySelector('.detail-gallery');
  const slides=[...root.querySelectorAll('.detail-image')];
  const counter=root.querySelector('.gallery-count');
  const select=root.querySelector('[data-variant-select]');
  const price=root.querySelector('[data-product-price]');
  const stickyPrice=document.querySelector('[data-sticky-price]');
  const submit=root.querySelector('[data-product-submit]');
  const stickyBuy=document.querySelector('[data-sticky-buy]');
  function goToImage(index){if(!gallery||!slides[index])return;gallery.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:'smooth'});}
  function updateCounter(){if(!gallery||!counter||!slides.length)return;const index=Math.min(slides.length-1,Math.max(0,Math.round(gallery.scrollLeft/(gallery.clientWidth||1))));counter.textContent=`${index+1} / ${slides.length}`;}
  gallery?.addEventListener('scroll',updateCounter,{passive:true});
  root.querySelector('.gallery-prev')?.addEventListener('click',()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));goToImage(Math.max(0,i-1));});
  root.querySelector('.gallery-next')?.addEventListener('click',()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));goToImage(Math.min(slides.length-1,i+1));});
  select?.addEventListener('change',()=>{
    const selected=select.selectedOptions[0];if(!selected)return;
    price.textContent=selected.dataset.price||'';
    if(selected.dataset.comparePrice){const s=document.createElement('s');s.textContent=selected.dataset.comparePrice;price.append(' ',s);}
    if(stickyPrice)stickyPrice.textContent=selected.dataset.price||'';
    const available=selected.dataset.available==='true';
    submit.disabled=!available;submit.textContent=available?'ADD TO BAG ↗':'SOLD OUT';
    if(stickyBuy){stickyBuy.disabled=!available;stickyBuy.textContent=available?'ADD TO BAG ↗':'SOLD OUT';}
    const target=slides.findIndex(el=>el.dataset.imageId===selected.dataset.imageId);
    if(target>=0)goToImage(target);
  });
  stickyBuy?.addEventListener('click',()=>{
    if(stickyBuy.disabled)return;
    const form=root.querySelector('.chrome-product-form');
    if(!form)return;
    if(form.reportValidity()){
      if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
    }
  });
});

// Option buttons synchronize with native variant selection and existing gallery/price logic.
document.addEventListener('DOMContentLoaded',()=>{
 const root=document.querySelector('[data-chrome-product]');if(!root)return;
 const select=root.querySelector('[data-variant-select]'),optionGroups=[...root.querySelectorAll('[data-option-position]')];
 const script=root.querySelector('[data-product-variants]');if(!select||!script||!optionGroups.length)return;
 let variants=[];try{variants=JSON.parse(script.textContent)}catch(e){return}
 const message=root.querySelector('[data-variant-message]');
 function selectedValues(){return optionGroups.map(group=>group.querySelector('[aria-pressed="true"]')?.dataset.optionValue||'')}
 function refresh(){
  const values=selectedValues();let variant=variants.find(v=>values.every((val,i)=>v.options[i]===val));
  const availableValues=variants.filter(v=>v.available);
  optionGroups.forEach((group,i)=>{
    const chosen=values[i];const label=group.querySelector('[data-option-label]');if(label)label.textContent=chosen;
    group.querySelectorAll('[data-option-value]').forEach(button=>{
      const same=button.dataset.optionValue===chosen;
      button.classList.toggle('is-selected',same);button.setAttribute('aria-pressed',String(same));
      const possible=availableValues.some(v=>v.options[i]===button.dataset.optionValue&&values.every((val,j)=>j===i||v.options[j]===val));
      button.classList.toggle('is-unavailable',!possible);
      button.setAttribute('aria-label',button.dataset.optionValue+(!possible?' (unavailable with selected options)':''));
    });
  });
  if(!variant){if(message)message.textContent='This combination is unavailable. Try another option.';root.querySelector('[data-product-submit]').disabled=true;const sticky=document.querySelector('[data-sticky-buy]');if(sticky)sticky.disabled=true;return;}
  if(message)message.textContent=!variant.available?'This variant is sold out.':'';
  select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));
 }
 optionGroups.forEach(group=>group.querySelectorAll('[data-option-value]').forEach(btn=>btn.addEventListener('click',()=>{
   group.querySelectorAll('[data-option-value]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));refresh();
 })));
 // The theme's native variant selector remains the actual form field.
 refresh();
});
